import { render, staticRenderFns } from "./znyxSystem.vue?vue&type=template&id=6084c71b&scoped=true&"
import script from "./znyxSystem.vue?vue&type=script&lang=js&"
export * from "./znyxSystem.vue?vue&type=script&lang=js&"
import style0 from "./znyxSystem.vue?vue&type=style&index=0&id=6084c71b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084c71b",
  null
  
)

export default component.exports